import { render, staticRenderFns } from "./SignalingSessions.vue?vue&type=template&id=64634de3"
import script from "./SignalingSessions.vue?vue&type=script&lang=js"
export * from "./SignalingSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports